export default __webpack_public_path__ + "static/proViotics-jar-front-with-pills-6f32af6d622491db6189664bd81de463.png";